<script>
export default {
    name: 'not-found',
}
</script>

<template>
    <h4 class="text-center">404 | Not Found</h4>
</template>
